export default function(
	$http, 
	$q, 
	$rootScope, 
	api, 
	Session, 
	$location, 
	$state, 
	_
) {
	"ngInject";
		
	function serializeObj(obj) {
		if (!_.isEmpty(obj)) {
			var result = [];
			for (var property in obj) result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
			return '?'+result.join("&");
		}
		return '';
	}
	
	function request(url, cache, data) {

		var sessionStr = url+serializeObj(data);

		var getRequest = function() {
			return $http({
				method: 'GET', 
				url: url, 
				params: data 
			})
			.then(function(res) {
				if (cache) {
					var expire = new Date();
					expire.setDate(expire.getDate()+3);

					Session.set(sessionStr, {
						expire: expire.getTime(),
						data: res.data
					});
				}
				return $q.resolve(res.data);
			})
			.catch(function(err) {
				console.log(err);
				return $q.reject(err);
			});
		};
		
		if(cache) {
			var session =  Session.get(sessionStr);

			if (session && session.expire > Date.now()) {
				return $q.resolve(session.data);
			} else {
				return getRequest();
			}
		} else {
			return getRequest();
		}
	}

	function post(url, method, data) {
		var deferred = $q.defer();

		if (!method) {
			method = 'POST';
		}
		
		return $http({
			method: method, 
			url: url, 
			data: data, 
		})
		.then(function(res) {
			return $q.resolve(res.data);
		})
		.catch(function(err) {
			console.log(err);
			return $q.reject(err);
		});
	}


	this.get = (uri, cache, data) => request(api + uri, cache, data);
	this.post = function(uri, method, data) {
		if(!method) {
			method = 'POST';
		}
		return post(api + uri, method, data);
	}
	this.request = (url, data, options) => {
		var deferred = $q.defer();

		if (options === undefined) {
			options = {};
		}
		options.url = api + url;
		options.data = data;

		$http(options)
		.success(function (data, status, headers) {
			deferred.resolve(data);
		})
		.error(function (error) {
			console.log(error);
			deferred.reject(error);
		});

		return deferred.promise;
	}

};


// WEBPACK FOOTER //
// ./app/shared/services/http.service.js